import { combineReducers } from 'redux';
import orderHistory from './fetch-order-history';
import adherenceHistory from './fetch-adherence-history';
import adherenceHistoryPagination from './adherence-history-pagination';
import loading from './loading';
import userImageStatus from './upload-user-image';
import profileForm from './profile-form';
import emailPreferences from './email-preferences';
import userBookmarks from './fetch-bookmarks';

export default combineReducers( {
	orderHistory,
	adherenceHistory,
	adherenceHistoryPagination,
	loading,
	userImageStatus,
	profileForm,
	emailPreferences,
	userBookmarks,
} );
